import { render, staticRenderFns } from "./ReMap.vue?vue&type=template&id=dc763e24&scoped=true&"
import script from "./ReMap.vue?vue&type=script&lang=js&"
export * from "./ReMap.vue?vue&type=script&lang=js&"
import style0 from "./ReMap.vue?vue&type=style&index=0&id=dc763e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc763e24",
  null
  
)

export default component.exports